<template>
  <div>
    <el-button icon="el-icon-plus" @click="newCustomers"></el-button>

    <!--新建客户-->
    <el-dialog :title="$t('message.newClient')" :visible.sync="newCustom" width="40%" :close-on-click-modal=false>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item :label="$t('message.customerName')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.customerType')" prop="type">
          <el-select v-model="form.type" :placeholder="$t('message.pleaseSelect')">
            <el-option v-for="item in typeList" :key="item.id" :label="item.descrip" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.salesman')">
          <el-select v-model="form.salesman" :placeholder="$t('message.pleaseSelect')">
            <el-option v-for="item in salesmanList" :key="item.emp_no" :label="item.emp_name" :value="item.emp_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.areaGrouping')">
          <el-select v-model="form.region" :placeholder="$t('message.pleaseSelect')">
            <el-option v-for="item in regionalGroupingList" :key="item.seq_id" :label="item.grp_name" :value="item.seq_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.priceGroupings')">
          <el-select v-model="form.price" :placeholder="$t('message.pleaseSelect')">
            <el-option v-for="item in priceGroupingList" :key="item.vipStar" :label="item.vipName" :value="item.vipStar"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.contacts')">
          <el-input v-model="form.contacts"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.contactNumber')" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.location')" prop="whereProvince">
          <el-row>
            <el-col :span="8">
              <el-select v-model="form.whereProvince" :placeholder="$t('message.province')" @change="queryAreaProvinceList(1)">
                <el-option v-for="item in areaProvinceList" :key="item.area_id" :label="item.descrip" :value="item.area_id" @click.native="changeRegion(item,1)"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8" v-show="!form.whereProvince==''">
              <el-select v-model="form.whereCity" :placeholder="$t('message.city')" @change="queryAreaProvinceList(2)">
                <el-option v-for="item in areaCityList" :key="item.area_id" :label="item.descrip" :value="item.area_id" @click.native="changeRegion(item,2)"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8" v-show="!form.whereCity==''">
              <el-select v-model="form.whereDistrict" :placeholder="$t('message.area')">
                <el-option v-for="item in areaDistrictList" :key="item.area_id" :label="item.descrip" :value="item.area_id" @click.native="changeRegion(item,3)"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('message.detailedAddress')" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="newReset('form')">{{$t("message.cancel")}}</el-button>
        <el-button type="primary" @click="newSubmit('form')">{{$t("message.confirm")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        newCustom:false, //新建客户
        form:{
          name:'', //客户名称
          type:'', //客户类型
          salesman:'', //业务员
          region:'', //区域分组
          price:'', //价格分组
          contacts:'', //联系人
          phone:'', //联系电话
          whereProvince:'', //所在区域 省
          whereCity:'', //所在区域 市
          whereDistrict:'', //所在区域 区
          provinceCityArea:'', //省市区
          address:'', //详细地址
          province:'', //省
          city:'', //市
          area:'', //区
          customID:'', //客户ID
          empID:'', //业务员ID
          areaID:'', //区域ID
          priceID:'', //价格ID
        },
        rules: {
          name: [{ required: true, message: this.$t("message.enterCustomerName"), trigger: 'blur' }],
          type: [{ required: true, message: this.$t("message.selectCustomerType"), trigger: 'change' }],
          phone: [{ required: true, message: this.$t("message.enterContactNumber"), trigger: 'blur' }],
          whereProvince: [{ required: true, message: this.$t("message.selectArea"), trigger: 'change' }],
          address: [{ required: true, message: this.$t("message.enterDetailedAddress"), trigger: 'blur' }],
          empID: [{ required: true, message: this.$t("message.selectSalesman"), trigger: 'change' }],
          areaID: [{ required: true, message: this.$t("message.selectRegionalGrouping"), trigger: 'change' }],
          priceID: [{ required: true, message: this.$t("message.selectPriceGroup"), trigger: 'change' }],
        },
        typeList:[], //客户类型列表
        salesmanList:[], //业务员列表
        regionalGroupingList:[], //区域分组列表
        priceGroupingList:[], //价格分组列表
        areaProvinceList:[], //区域列表 省
        areaCityList:[], //区域列表 市
        areaDistrictList:[], //区域列表 区
      };
    },
    created(){

    },
    methods: {
      //查询客户类型列表
      queryCustomerTypes(){
        let _this=this;
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/customer.CustomerMgr/getCustType?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this.typeList=res.data.custTypeList;
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //查询业务员分页数据
      querySalesmanPagingData(){
        let _this=this;
        let obj={
          start:0, //数据起始数,
          limit:1000, //每页数据条数,
          ordersort:'emp_no desc', //排序,
          emp_name:'', //业务员名称
        };
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/salesman.SalesmanMgr/querySalesman?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this.salesmanList=res.data.resultlist;
            _this.salesmanList.unshift({
              emp_no:0, //业务员id
              emp_name:_this.$t("message.nothing"), //业务员名称
            })
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //查询区域分组列表
      queryAreaGroupList(){
        let _this=this;
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/customer.CustomerMgr/queryAreaGrp?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this.regionalGroupingList=res.data.resultlist;
            _this.regionalGroupingList.unshift({
              seq_id:0, //id
              grp_name:_this.$t("message.nothing"), //区域名称
            })
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //查询价格分组列表
      queryPriceGroupingList(){
        let _this=this;
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/customer.CustVipdefMgr/getValidCustVipdef?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this.priceGroupingList=res.data.vipdefList;
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //查询区域列表数据
      queryAreaProvinceList(i){
        let _this=this;
        let pid = 0;
        let str = '';
        if(i === undefined){
          pid = 0;
          str = 'areaProvinceList';
        }else if(i === 1){
          pid = _this.form.whereProvince;
          str = 'areaCityList';
          _this.form.whereCity = '';
          _this.form.city = '';
          _this.form.whereDistrict = '';
          _this.form.area = '';
          _this.areaDistrictList = [];
          _this[str] = [];
        }else{
          pid = _this.form.whereCity;
          str = 'areaDistrictList';
          _this.form.whereDistrict = '';
          _this.form.area = '';
          _this[str] = [];
        }
        _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/dict.PubDict/listArea?sessionid='+_this.$store.state.Login.sessionid,{pid:pid}).then(function(res){
//          console.log(res.data);
          if(res.data.ret_status=='ok'){
            _this[str]=res.data.resultlist;
          }else {
            _this.openWar(res.data.rpc_msg)
          }
        }).catch(function (error) {
          _this.openErr(_this.$t("message.requestFailure"));
        });
      },
      //选择省市区名称
      changeRegion(item,i){
        if(i === 1){
          this.form.province=item.descrip;
        }else if(i === 2){
          this.form.city=item.descrip;
        }else{
          this.form.area=item.descrip;
        }
      },
      //新建客户
      newCustomers(){
        this.emptyKEY();
        this.queryCustomerTypes(); //查询客户类型列表
        this.querySalesmanPagingData(); //查询业务员分页数据
        this.queryAreaGroupList(); //查询区域分组列表数据
        this.queryPriceGroupingList(); //查询价格分组列表
        this.queryAreaProvinceList(); //查询区域列表数据
        this.newCustom=true;
      },
      //新建客户
      newSubmit(formName){
        let _this=this;
        _this.$refs[formName].validate((valid) => {
          if (valid) {
            let addrArea = '';
            let shipCity = '';
            if(_this.form.whereDistrict === '' && _this.form.whereCity === ''){
              addrArea = _this.form.whereProvince;
              shipCity = _this.form.province;
            }else{
              addrArea =_this.form.whereDistrict === ''?_this.form.whereCity: _this.form.whereDistrict;
              shipCity = _this.form.whereDistrict === ''?_this.form.province+'&'+_this.form.city:_this.form.province+'&'+_this.form.city+'&'+_this.form.area;
            }
            let obj={
              addr:_this.form.address, //详细地址
              addrArea:addrArea, //客户地址，省市县镇最后一级id
              areaGrpId:_this.form.region==''?0:_this.form.region, //所属区域分组id
              avatarPaths:'', //头像地址
              custId:0, //客户id，编辑时传
              custName:_this.form.name, //客户名称
              custType:_this.form.type, //客户分类
              linkPhone:_this.form.phone, //联系电话
              postCode:'', //邮编
              saleman:_this.form.salesman==''?0:_this.form.salesman, //业务员id即emp_no
              shipCity:shipCity, //省、市、县、街道名称，用“&”连接
              shipName:_this.form.contacts, //联系人
              states:1, //审核状态，审核时才传，1同意，2拒绝
              vipStar:_this.form.price==''?0:_this.form.price, //客户分组id
            };
            _this.axios.post(_this.$store.state.urlHttp+'/xx_admin/customer.CustomerMgr/addCustomer?sessionid='+_this.$store.state.Login.sessionid,obj).then(function(res){
//              console.log(res.data);
              if(res.data.ret_status=='ok'){
                _this.openSucc(res.data.rpc_msg);
                _this.$refs[formName].resetFields();
                _this.newCustom=false;
                _this.emptyKEY();
              }else {
                _this.openWar(res.data.rpc_msg)
              }
            }).catch(function (error) {
              _this.openErr(_this.$t("message.requestFailure"));
            });
          } else {
            return false;
          }
        });
      },
      //取消新建
      newReset(formName) {
        this.$refs[formName].resetFields();
        this.emptyKEY();
        this.newCustom=false;
      },
      //清空KEY值
      emptyKEY(){
        this.form.name='';
        this.form.type='';
        this.form.region='';
        this.form.price='';
        this.form.contacts='';
        this.form.phone='';
        this.form.whereProvince='';
        this.form.whereCity='';
        this.form.whereDistrict='';
        this.form.provinceCityArea='';
        this.form.address='';
        this.form.province='';
        this.form.city='';
        this.form.area='';
        this.form.customID='';
        this.form.empID='';
        this.form.areaID='';
        this.form.priceID='';
      },
    }
  };
</script>

<style lang="less" scoped>
  .el-input, .el-select{
    width: 100%;
  }
  .el-form-item{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/newCustomers.vue